import { ActionReducerMap } from '@ngrx/store';
import { AppState } from '../task.state';
import * as fromReducer from './task.reducer';

export const reducers: ActionReducerMap<AppState> = {
  taskState: fromReducer.taskReducer
}; 